import { Resume } from '../../resume/resume';
import { convertResumeJsonToMarkdown } from './get-resume-content.prompt';

export function getCustomerSummaryPrompt(config: { resume: Resume }) {
  const resumeMarkdownContent = convertResumeJsonToMarkdown(config.resume?.subData?.content as any, true);

  return `Based on the following resume information:
<RESUME_INFORMATION>
${resumeMarkdownContent}
</RESUME_INFORMATION>

Research the companies the prospect has worked at.

Gather the following information:
1. Current Compnay and Role
   - The industry of the company
   - The size of the company

2. Prospect's Pain Points
The typical concerns or challenges the prospect is facing as the role in the company, in the industry.
Output in bullet points. Be concise, direct.

3. Past Experience and Roles.
- Include an oneliner summarization for each of the companies the prospect has worked at. Include the following details:
    - Including The industry of the company and The size of the company.
    - The role
    - The years of the prospects worked.
Output in one line for each company.

4. Personal Outreach Message
Create a short direct, concise, personal outreach message to the prospect attending to the First Name of the prospect for a conversation to improve their sales process.
The message should not include template "[First Name]" in the output. Use specific values of First Name if it exists in the customer info.
The message should take into account the paintpoints and current and past experience but don't explicitly mention them.
Avoid using generic words such as "current role" or "past experience" or "some of the challenges" or "strong background in software engineering and leadership" in the message.
Always use specific details from the paintpoints and current and past experience from information gathered in step 1,2 and 3.
Do not add closing.


Keep each section brief and to the point. Only output the results in cleaned structured text format.
Output in the following format strictly following the order:
- Current Company and Role
- Prospect's Pain Points
- Personal Outreach Message
- Past Experience and Roles.
`;
}
